const cafeServiceName = "/Cafe";

export function categoryService (http) {
    return {
        getAllCategoriesAsync: async (pageNumber, pageSize, sortBy, filters) => {
            const newSort = (sortBy || []).map(item => ({
                member: item.id,
                sortDirection: item.desc ? "Descending" : "Ascending"
            }));
            const filter=filters;
            const data = {
                dataAttribute:{
                    page:pageNumber,
                    pageSize,
                    sorts: newSort.lenght==0?[{member:"Id",sortDirection:"Ascending"}]:newSort,
                    filter: filter
                }
            }
            return await http.post(cafeServiceName + '/GetAllCafeCategories', data);
        },
        saveNewCategoryAsync: async (categoryName) => {
            const parameters = {
                name: categoryName
            }
            return (await http.post(cafeServiceName + '/SaveNewCategoryAsync', parameters));
        },
        deleteExistingCategoryAsync: async (categoryId) => {
            const parameters = {
                id: categoryId
            }
            return (await http.post(cafeServiceName + '/DeleteExistingCategoryAsync', parameters));
        },
        updateExistingCategoryAsync: async (categoryObject) => {
            debugger;
            return (await http.post(cafeServiceName + '/UpdateExistingCategoryAsync', categoryObject));
        }
    }
}